import {
  UpsertPrivateMutationVariables,
  PrivateQueryVariables,
} from '@school_ify/schoolify-repository/src/shared/types';
import {
  getPrivate,
  upsertPrivate,
} from '@school_ify/schoolify-repository/src/shared/repositories/userRepository';

class EditProfileService {
  public async updateUserData(
    personalData: any
  ): Promise<Readonly<UpsertPrivateMutationVariables>> {
    try {
      const data = await upsertPrivate(personalData);
      // @ts-ignore
      return data;
    } catch (err) {
      throw new Error(`Error updating teacher data: ${err}`);
    }
  }

  public async getUserPrivateData(): Promise<PrivateQueryVariables> {
    try {
      const data = await getPrivate();
      // @ts-ignore
      return data;
    } catch (err) {
      throw new Error(`Error getting data: ${err}`);
    }
  }
}

export default new EditProfileService();
